module.exports = __webpack_public_path__ + "2754be1e9848a69217818caafcf247e1.svg";